import {
  SectionBasic,
  SectionExpertsCarousel,
} from '@sbercloud/uikit-product-site-section';
import { useMemo } from 'react';
import { VideoPlayer } from 'src/components/VideoPlayer';
import { useLayoutType } from 'src/hooks/useLayoutType';
import { WebinarType } from 'src/types/backendContent';
import { ProductsList } from 'src/uikit/ProductsList';

import s from '../Event.module.scss';

// TODO: replace image with a better one or update component SectionExperts
const FALLBACK_IMAGE =
  'https://cdn.cloud.ru/backend/images/webinars/no_avatar.png';

type WebinarContentProps = WebinarType;

export function WebinarContent(props: WebinarContentProps) {
  const { recordLink, description, lectors, products } = props;
  const layoutType = useLayoutType();

  const experts = useMemo(() => {
    return lectors.map((lector) => ({
      image: lector.avatar || FALLBACK_IMAGE,
      name: lector.secondName,
      surname: lector.name,
      jobTitle: lector.position,
    }));
  }, [lectors]);

  return (
    <>
      <SectionBasic layoutType={layoutType}>
        {recordLink && (
          <div id="video-player" className={s.videoPlayer}>
            <VideoPlayer
              previewImage="https://cdn.cloud.ru/backend/images/webinars/preview_video.png"
              link={recordLink}
              customError
              controls
            />
          </div>
        )}
        <div
          className={s.description}
          dangerouslySetInnerHTML={{ __html: description }}
          data-layout-type={layoutType}
        />
      </SectionBasic>
      {lectors.length > 0 && (
        <SectionExpertsCarousel
          title="Спикеры"
          items={experts}
          backgroundColor="neutral-background1-level"
          layoutType={layoutType}
        />
      )}
      {products?.length > 0 && (
        <ProductsList
          title="Продукты, про которые расскажем"
          products={products}
        />
      )}
    </>
  );
}
